import {
  LiveKitRoom,
  VideoConference,
  PreJoin,
} from "@livekit/components-react";
import "@livekit/components-styles";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../../constant/localStorage";
import { Result, Button, Spin } from "antd";
import { ROUTES } from "../../../constant/routes";
import { StyledMeetingRoom } from "./styles";
import httpClient from "../../../api/httpClient";

const MeetingRoom = () => {
  const { roomId } = useParams();

  const [mediaSettings, setMediaSettings] = useState({
    videoDeviceId: null,
    audioEnabled: true,
    videoEnabled: true,
  });

  const [{ host, token, loading }, setRoomData] = useState({
    host: null,
    token: null,
    loading: true,
  });

  useEffect(() => {
    const fetchRoomData = async () => {
      try {
        const { host, token } = getLocalStorageItem(roomId) || {};

        if (host && token) {
          setRoomData({ host, token, loading: false });
          return;
        }
        const { data } = await httpClient.post("calls/join", {
          room_code: roomId,
        });

        if (data?.token && data?.host) {
          setLocalStorageItem(roomId, { host: data.host, token: data.token });
          setRoomData({
            host: data.host,
            token: data.token,
            loading: false,
          });
        } else throw Error("Invalid room data received from server");
      } catch (err) {
        console.error("Error fetching room data:", err);
        setRoomData({
          host: null,
          token: null,
          loading: false,
        });
      }
    };

    fetchRoomData();
  }, [roomId]);

  return (
    <StyledMeetingRoom data-lk-theme="default">
      {loading ? (
        <div className="w-100  h-100 flex justify-center align-center">
          <Spin />
        </div>
      ) : host && token ? (
        <>
          {!mediaSettings?.videoDeviceId ? (
            <PreJoin onSubmit={setMediaSettings} joinLabel="Join Meeting" />
          ) : (
            <LiveKitRoom
              serverUrl={host}
              token={token}
              connect
              audio={mediaSettings.audioEnabled}
              video={mediaSettings.videoEnabled}
            >
              <VideoConference />
            </LiveKitRoom>
          )}
        </>
      ) : (
        <Result
          status="404"
          title="Invalid Meeting"
          subTitle="Room not found or session expired."
          extra={
            <Button
              type="primary"
              onClick={() => (window.location.href = ROUTES.DASHBOARD)}
            >
              Go Home
            </Button>
          }
        />
      )}
    </StyledMeetingRoom>
  );
};

export default MeetingRoom;
